module.exports = __webpack_public_path__ + "static/04-6334a5ca360c1bc4f83f95c96dbadfd6.jpg";